import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import {InputSwitch} from "primereact/inputswitch";

const ProjecttypeFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [warehouses, setWarehouses] = useState([]);
  const [formData, setFormData] = useState({
    casual_project: false,
    continuous_fulfillment: false,
    main_contractor_fulfillment_enabled: true,
    subcontractor_fulfillment_enabled: true,
    project_creation_trigger: 'OFFER_ACCEPTED',
    warehouse_mode: 'NONE',
    cost_center_mode: 'PROJECT',
  });

  const validate = (data) => {
    let errors = {};
    if ((data.warehouse_mode || formData.warehouse_mode) === 'SHARED' && !(data.warehouse || formData.warehouse)) {
      errors.warehouse = t('fieldRequired');
    }
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if ((window.App.urlVars().projectTypeId) || (entity === 'project-type' && id)) {
      apiCall('patch', '/api/v2/project-type/' + id, data)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({
            rerenderProjecttypeList: Math.random(),
            rerenderProjectPage: Math.random()
          })
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/project-type', data)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({
            rerenderProjecttypeList: Math.random(),
            rerenderProjectPage: Math.random()
          })
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/hr/project-type/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    apiCall('get', '/api/v2/warehouse?item_per_page=9999&sort=name&direction=asc')
      .then(response => setWarehouses(response.data?.data?.items || []))
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });

    // let _emloyeeQuery = {
    //   rows: 9999
    // }
    // let emloyeeQuery = window.App.transformQueryParams(_emloyeeQuery)
    if ((!window.App.urlVars().create && window.App.urlVars().projecttypeId) || (entity === 'project-type' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/project-type/' + (window.App.urlVars().projectId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  return (
    <div className={"project-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-10"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-2"}>
              <Field name="active" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="active"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldActive')}</label>
                  <span className="p-d-block">
                    <InputSwitch
                      className={"p-mt-1"}
                      checked={formData.active}
                      value={formData.active}
                      onChange={e => setFormData({...formData, active: e.target.value})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className="p-col-12 p-mt-2">
              <style>{`
                .project-type-settings > .p-col-12 {
                  width: 100%;
                  padding-top: 0.5rem;
                  padding-bottom: 0.5rem;
                }
                .project-type-settings .p-field,
                .project-type-switch-settings .p-d-flex {
                  display: grid !important;
                  grid-template-columns: minmax(0, 1fr) 18rem;
                  align-items: center;
                  column-gap: 2rem;
                  margin-bottom: 0;
                }
                .project-type-settings .p-field > span {
                  width: 100%;
                }
                .project-type-settings .p-dropdown {
                  width: 100%;
                }
                .project-type-switch-settings .p-inputswitch {
                  justify-self: end;
                }
                @media screen and (max-width: 640px) {
                  .project-type-settings .p-field,
                  .project-type-switch-settings .p-d-flex {
                    grid-template-columns: minmax(0, 1fr) minmax(10rem, 45%);
                    column-gap: 1rem;
                  }
                }
              `}</style>
              <div className="p-p-3" style={{border: '1px solid #dee2e6', borderRadius: '6px'}}>
                <h3 className="p-mt-0 p-mb-3">{t('projectTypeSettings')}</h3>
                <div className="project-type-settings">
            <div className={"p-col-12 p-lg-4"}>
              <Field name="value_partner" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="value_partner"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldPartner')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions([
                       {
                         value: 'mandatory',
                         key: 'Kötelező'
                       },
                       {
                         value: 'disabled',
                         key: 'Kikapcsolva'
                       }
                     ], "key")}
                               id={"value_partner"}
                               optionValue={"value"}
                               optionLabel={"key"}
                               emptyMessage={t('noElementYet')}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   value_partner: e.value
                                 })
                               }}
                               value={formData.value_partner?.id || formData.value_partner}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="value_contract" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="value_contract"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('contract')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions([
                       {
                         value: 'mandatory',
                         key: 'Kötelező'
                       },
                       {
                         value: 'optional',
                         key: 'Opcionális'
                       },
                       {
                         value: 'disabled',
                         key: 'Kikapcsolva'
                       }
                     ], "key")}
                               id={"value_contract"}
                               optionValue={"value"}
                               optionLabel={"key"}
                               emptyMessage={t('noElementYet')}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   value_contract: e.value
                                 })
                               }}
                               value={formData.value_contract?.id || formData.value_contract}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="value_deadline" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="value_deadline"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('deadline')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions([
                       {
                         value: 'mandatory',
                         key: 'Kötelező'
                       },
                       {
                         value: 'optional',
                         key: 'Opcionális'
                       },
                       {
                         value: 'disabled',
                         key: 'Kikapcsolva'
                       }
                     ], "key")}
                               id={"value_deadline"}
                               optionValue={"value"}
                               optionLabel={"key"}
                               emptyMessage={t('noElementYet')}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   value_deadline: e.value
                                 })
                               }}
                               value={formData.value_deadline?.id || formData.value_deadline}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="value_external_id" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="value_external_id"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('externalReference')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions([
                       {
                         value: 'mandatory',
                         key: 'Kötelező'
                       },
                       {
                         value: 'optional',
                         key: 'Opcionális'
                       },
                       {
                         value: 'disabled',
                         key: 'Kikapcsolva'
                       }
                     ], "key")}
                               id={"value_external_id"}
                               optionValue={"value"}
                               optionLabel={"key"}
                               emptyMessage={t('noElementYet')}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   value_external_id: e.value
                                 })
                               }}
                               value={formData.value_external_id?.id || formData.value_external_id}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="warehouse_mode" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="warehouse_mode"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldProjectWarehouse')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions([
                       {
                         value: 'NONE',
                         key: t('projectWarehouseModeNone')
                       },
                       {
                         value: 'DEDICATED',
                         key: t('projectWarehouseModeDedicated')
                       },
                       {
                         value: 'SHARED',
                         key: t('projectWarehouseModeShared')
                       }
                     ], "key")}
                               id={"warehouse_mode"}
                               optionValue={"value"}
                               optionLabel={"key"}
                               emptyMessage={t('noElementYet')}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   warehouse_mode: e.value,
                                   warehouse: e.value === 'SHARED' ? formData.warehouse : null,
                                 })
                               }}
                               value={formData.warehouse_mode?.id || formData.warehouse_mode}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            {formData.warehouse_mode === 'SHARED' &&
              <div className={"p-col-12 p-lg-4"}>
                <Field name="warehouse" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="warehouse"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldWarehouse')}</label>
                    <span className="p-d-block">
                      <Dropdown
                        id="warehouse"
                        options={window.App.sortDropdownOptions(warehouses, 'name')}
                        optionValue="id"
                        optionLabel="name"
                        filter
                        showClear
                        emptyMessage={t('noWarehouseYet')}
                        onChange={(e) => setFormData({...formData, warehouse: e.value})}
                        value={formData.warehouse?.id || formData.warehouse}
                        className={classNames({'p-invalid': isFormFieldValid(meta)})}
                      />
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            }
            <div className={"p-col-12 p-lg-4"}>
              <Field name="cost_center_mode" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="cost_center_mode"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('fieldProjectCostCenterMode')}</label>
                  <Dropdown
                    id="cost_center_mode"
                    options={[
                      {value: 'NONE', name: t('projectCostCenterMode.NONE')},
                      {value: 'PROJECT', name: t('projectCostCenterMode.PROJECT')},
                      {value: 'PROJECT_AND_ITEMS', name: t('projectCostCenterMode.PROJECT_AND_ITEMS')},
                    ]}
                    optionValue="value"
                    optionLabel="name"
                    value={formData.cost_center_mode?.value || formData.cost_center_mode || 'PROJECT'}
                    onChange={(e) => setFormData({...formData, cost_center_mode: e.value})}
                  />
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="value_location" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="value_location"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldProjectLocation')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions([
                       {
                         value: 'mandatory',
                         key: 'Kötelező'
                       },
                       {
                         value: 'disabled',
                         key: 'Kikapcsolva'
                       }
                     ], "key")}
                               id={"value_location"}
                               optionValue={"value"}
                               optionLabel={"key"}
                               emptyMessage={t('noElementYet')}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   value_location: e.value
                                 })
                               }}
                               value={formData.value_location?.id || formData.value_location}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="value_milestone" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="value_milestone"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldProjectMilestone')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions([
                       {
                         value: 'mandatory',
                         key: 'Kötelező'
                       },
                       {
                         value: 'disabled',
                         key: 'Kikapcsolva'
                       }
                     ], "key")}
                               id={"value_milestone"}
                               optionValue={"value"}
                               optionLabel={"key"}
                               emptyMessage={t('noElementYet')}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   value_milestone: e.value
                                 })
                               }}
                               value={formData.value_milestone?.id || formData.value_milestone}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="value_warranty_expiry_date" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="value_warranty_expiry_date"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldWarrantyExpiryDate')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions([
                                {
                                  value: 'mandatory',
                                  key: 'Kötelező'
                                },
                                {
                                  value: 'optional',
                                  key: 'Opcionális'
                                },
                                {
                                  value: 'disabled',
                                  key: 'Kikapcsolva'
                                }
                              ], "key")}
                               id={"value_warranty_expiry_date"}
                               optionValue={"value"}
                               optionLabel={"key"}
                               emptyMessage={t('noElementYet')}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   value_warranty_expiry_date: e.value
                                 })
                               }}
                               value={formData.value_warranty_expiry_date?.id || formData.value_warranty_expiry_date}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

                </div>
                <div className="project-type-switch-settings">
                <Field name="project_status_directly_settable" render={({input, meta}) => (
                  <div className="p-d-flex p-jc-between p-ai-center p-py-2">
                    <label htmlFor="project_status_directly_settable"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{t('fieldProjectStatusDirectlySettable')}</label>
                    <InputSwitch
                      id="project_status_directly_settable"
                      checked={formData.project_status_directly_settable}
                      onChange={e => setFormData({...formData, project_status_directly_settable: e.value})}/>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
                <Field name="continuous_fulfillment" render={({input, meta}) => (
                  <div className="p-d-flex p-jc-between p-ai-center p-py-2">
                    <label htmlFor="continuous_fulfillment"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{t('fieldContinuousFulfillment')}</label>
                    <InputSwitch
                      id="continuous_fulfillment"
                      checked={formData.continuous_fulfillment}
                      onChange={e => {
                        input.onChange(e.value);
                        setFormData({...formData, continuous_fulfillment: e.value});
                      }}/>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
                <Field name="project_creation_trigger" render={({input, meta}) => (
                  <div className="p-field p-fluid p-py-2">
                    <label htmlFor="project_creation_trigger"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{t('fieldProjectCreationTrigger')}</label>
                    <Dropdown id="project_creation_trigger"
                              value={formData.project_creation_trigger || 'OFFER_ACCEPTED'}
                              options={[
                                {label: t('projectCreationTrigger.OFFER_ACCEPTED'), value: 'OFFER_ACCEPTED'},
                                {label: t('projectCreationTrigger.ORDER_CONFIRMED'), value: 'ORDER_CONFIRMED'},
                                {label: t('projectCreationTrigger.MANUAL'), value: 'MANUAL'},
                              ]}
                              onChange={e => {
                                input.onChange(e.value);
                                setFormData({...formData, project_creation_trigger: e.value});
                              }}/>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
                <Field name="main_contractor_fulfillment_enabled" render={({input, meta}) => (
                  <div className="p-d-flex p-jc-between p-ai-center p-py-2">
                    <label htmlFor="main_contractor_fulfillment_enabled"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{t('fieldMainContractorFulfillmentEnabled')}</label>
                    <InputSwitch id="main_contractor_fulfillment_enabled"
                      checked={formData.main_contractor_fulfillment_enabled !== false}
                      onChange={e => {
                        input.onChange(e.value);
                        setFormData({...formData, main_contractor_fulfillment_enabled: e.value});
                      }}/>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
                <Field name="subcontractor_fulfillment_enabled" render={({input, meta}) => (
                  <div className="p-d-flex p-jc-between p-ai-center p-py-2">
                    <label htmlFor="subcontractor_fulfillment_enabled"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{t('fieldSubcontractorFulfillmentEnabled')}</label>
                    <InputSwitch id="subcontractor_fulfillment_enabled"
                      checked={formData.subcontractor_fulfillment_enabled !== false}
                      onChange={e => {
                        input.onChange(e.value);
                        setFormData({...formData, subcontractor_fulfillment_enabled: e.value});
                      }}/>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            </div>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'project-type' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(ProjecttypeFormComponent);
